import { ErrorDebugInfos, RESERVED_ERROR_CODES } from "@cervval.js/common/src/errors/errors";

export type RouteMethods = "post" | "get" | "put" | "delete";

/**
 * Standard response
 */
export interface RouteFunctionJsonResponse {
    code: number;// http code (200 = ok)
    result: unknown;
}

export enum SuccessCodes {
    OK = 200,
    CREATED = 201,
    ACCEPTED = 202
}

//#region Errors

/**
 * Standard error response
 */
export interface RouteErrorJsonResponse {
    code: number;// Error code (can be http [200-599] or application dependent [600-799])
    error: true;
    errorMessage?: string;// The error message to display to the user (if undefined, a standard error will be displayed by client based on the code)
    debugInfos?: ErrorDebugInfos;// This is not sent to client in production
    noDialog?: boolean; // No dialog box will be displayed by client
}

/**
 * @returns true if response is a RouteErrorJsonResponse
 */
export function isErrorResponse(response: RouteFunctionJsonResponse | RouteErrorJsonResponse | undefined): response is RouteErrorJsonResponse {
    const errorResponse = <RouteErrorJsonResponse>response;
    return response == null || errorResponse.error;
}


export enum ErrorCodes {
    RESERVED = RESERVED_ERROR_CODES, // * You can check all reserved codes here

    /**
     * Client errors (400–429)
     */
    BAD_REQUEST = 400,// WRONG PARAMETERS
    UNAUTHORIZED = 401,// NOT AUTHENTICATED
    FORBIDDEN = 403,// ACCESS DENIED
    NOT_FOUND = 404,
    REQUEST_TIMEOUT = 408,
    CONFLICT = 409,

    /**
     * Server errors (500–529)
     */
    INTERNAL_ERROR = 500,
    IO_ERROR = 520,
}

/**
 * @returns true if errorCode should be set as HTTP status on a error response
 */
export function isHttpStatusErrorCode(errorCode: number): boolean {
    return errorCode >= ErrorCodes.BAD_REQUEST && errorCode <= ErrorCodes.BAD_REQUEST + 29 ||
        errorCode >= ErrorCodes.INTERNAL_ERROR && errorCode <= ErrorCodes.INTERNAL_ERROR + 29;
}

//#endregion Errors

/** FormData keys to upload information by routes */
export enum FormDataKeys {
    FUNCTION_PARAMETERS = "data", // key to collect and send function parameters
    UPLOAD_FILES = "files" // key to collect and send uploaded files
}